<template>
  <v-row>
    <!-- Inactive -->
    <v-col cols="3" class="border-right-dashed">
      <draggable
        :class="{
          inactive: !enabled || readOnly,
          draggable: allowedLevels.includes('inactive'),
        }"
        :list="list0"
        :group="{ name: behaviourComponent, level: 'inactive' }"
        :move="checkMove"
        style="min-height: 100px"
        :disabled="!enabled || readOnly"
        @end="onEnd"
        @start="onStart"
      >
        <v-card
          class="list-group-item pa-3"
          v-for="element in list0"
          align="center"
          :key="element.name"
          color="#f2f8ff"
        >
          <span>
            <v-icon color="#0057c2">{{ icon }}</v-icon>
          </span>
          <p>{{ $app.behaviourComponentManager.getBehaviourComponentName(element.name) }}</p>
        </v-card>
      </draggable>
    </v-col>

    <!-- Start action -->
    <v-col cols="3" v-if="enabled">
      <draggable
        :class="{
          disabled: readOnly,
          start_action: true,
          draggable: allowedLevels.includes('start_action'),
        }"
        :list="list1"
        :group="{ name: behaviourComponent, level: 'start_action' }"
        :move="checkMove"
        style="min-height: 100px"
        :disabled="!enabled || readOnly"
        @end="onEnd"
        @start="onStart"
      >
        <v-card
          class="list-group-item pa-3"
          v-for="element in list1"
          align="center"
          :key="element.name"
          color="#f2f8ff"
        >
          <span>
            <v-icon color="#0057c2">{{ icon }}</v-icon>
          </span>
          <p>{{ $app.behaviourComponentManager.getBehaviourComponentName(element.name) }}</p>
        </v-card>
      </draggable>
    </v-col>

    <!-- Note: Release 2.0 scope reduction  -->
    <!-- Planned action -->
    <!-- <v-col cols="2" v-if="enabled">
      <draggable
        :class="{
          planned_action: true,
          draggable: allowedLevels.includes('planned_action'),
        }"
        :list="list2"
        :group="{ name: behaviourComponent, level: 'planned_action' }"
        :move="checkMove"
        style="min-height: 100px"
        @end="onEnd"
        :disabled="!enabled"
      >
        <v-card
          class="list-group-item pa-3"
          v-for="element in list2"
          align="center"
          :key="element.name"
          color="#f2f8ff"
        >
          <span>
            <v-icon color="#0057c2">{{ icon }}</v-icon>
          </span>
          <p>{{ $app.behaviourComponentManager.getBehaviourComponentName(element.name) }}</p>
        </v-card>
      </draggable>
    </v-col> -->

    <!-- Monitored action -->
    <v-col cols="3" v-if="enabled">
      <draggable
        :class="{
          disabled: readOnly,
          monitored_action: true,
          draggable: allowedLevels.includes('monitored_action'),
        }"
        :list="list3"
        :group="{ name: behaviourComponent, level: 'monitored_action' }"
        :move="checkMove"
        style="min-height: 100px"
        :disabled="!enabled || readOnly"
        @end="onEnd"
        @start="onStart"
      >
        <v-card
          class="list-group-item pa-3"
          v-for="element in list3"
          align="center"
          :key="element.name"
          color="#f2f8ff"
        >
          <span>
            <v-icon color="#0057c2">{{ icon }}</v-icon>
          </span>
          <p>{{ $app.behaviourComponentManager.getBehaviourComponentName(element.name) }}</p>
        </v-card>
      </draggable>
    </v-col>

    <!-- Maintained behaviour -->
    <v-col cols="3" v-if="enabled">
      <draggable
        :class="{
          disabled: readOnly,
          maintained_behaviour: true,
          draggable: allowedLevels.includes('maintained_behaviour'),
        }"
        :list="list4"
        :group="{ name: behaviourComponent, level: 'maintained_behaviour' }"
        :move="checkMove"
        style="min-height: 100px"
        :disabled="!enabled || readOnly"
        @end="onEnd"
        @start="onStart"
      >
        <v-card
          class="list-group-item pa-3"
          v-for="element in list4"
          align="center"
          :key="element.name"
          style="min-height: 100px"
          color="#f2f8ff"
        >
          <span>
            <v-icon color="#0057c2">{{ icon }}</v-icon>
          </span>
          <p>{{ $app.behaviourComponentManager.getBehaviourComponentName(element.name) }}</p>
        </v-card>
      </draggable>
    </v-col>
  </v-row>
</template>


<script>
import draggable from "vuedraggable";
import gql from "graphql-tag";
import { mapGetters } from "vuex";

/**
 * Component BehaviourComponentDecisionDragAndDrop.vue
 *
 * @module BehaviourComponentDecisionDragAndDrop
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/BehaviourComponentDecisionDragAndDrop.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "BehaviourComponentDecisionDragAndDrop",
  props: {
    behaviourComponent: {
      type: String,
    },
    allowedLevels: {
      type: Array,
    },
    icon: {
      type: String,
    },
    activeLevel: {},
    enabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data: function () {
    return {
      list0: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
    };
  },
  watch: {
    activeLevel() {
      this.setActiveLevel();
    },
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      enabledModules: "enabledModules/getEnabledModules",
      readOnly: "user/hasReadOnlyAccess"
    }),
  },
  methods: {
    //   Disable dragging to certain columns
    checkMove: function (evt) {
      if (
        typeof evt.relatedContext.component.$attrs.group &&
        !this.allowedLevels.includes(
          evt.relatedContext.component.$attrs.group.level
        ) &&
        evt.draggedContext.component?.$attrs.group.name !=
          this.behaviourComponent
      ) {
        return false;
      }
    },

    onStart: function () {
      // add class on a higher level to set grabbing cursor while dragging
      document.querySelector('.v-application').classList.add('cursor-grabbing');
    },

    onEnd: function (evt) {
      let to = evt.to.classList[0];
      let from = evt.from.classList[0]

      // remove grabbing cursor class when dropped
      document.querySelector('.v-application').classList.remove('cursor-grabbing');

      if (to === 'draggable'){
        to = 'inactive';
      }
      if (from === 'draggable'){
        from = 'inactive';
      }

      this.showMessage(evt.originalEvent)

      if (to !== from) {
        this.setLOGBehaviourComponent(
            this.allowedLevels.indexOf(to)
        );
      }
    },

    setLOGBehaviourComponent(LOG) {
      this.$app.apolloMobileClient
        .mutate({
          mutation: gql`
            mutation updateMyBehaviourComponent(
              $patientId: Int
              $key: String!
              $levelOfGuidance: Int!
            ) {
              updateMyBehaviourComponent(
                patientId: $patientId
                key: $key
                levelOfGuidance: $levelOfGuidance
              ) {
                status
                levelOfGuidance
                key
                stageKey
              }
            }
          `,
          variables: {
            patientId: parseInt(this.patientId),
            key: this.behaviourComponent,
            levelOfGuidance: LOG,
          },
        })
        .then((result) => {
          this.$store.dispatch("patientSummary/set", this.patientId);
        });
    },

    setActiveLevel() {
      this.list0 = [];
      this.list1 = [];
      this.list2 = [];
      this.list3 = [];
      this.list4 = [];

      let activeLabel = this.allowedLevels[parseInt(this.activeLevel)];
      switch (activeLabel) {
        case "inactive":
          this.list0 = [{ name: this.behaviourComponent, id: 1 }];
          break;
        case "start_action":
          this.list1 = [{ name: this.behaviourComponent, id: 1 }];
          break;
        case "planned_action":
          this.list2 = [{ name: this.behaviourComponent, id: 1 }];
          break;
        case "monitored_action":
          this.list3 = [{ name: this.behaviourComponent, id: 1 }];
          break;
        case "maintained_behaviour":
          this.list4 = [{ name: this.behaviourComponent, id: 1 }];
          break;
      }
    },

     showMessage(originalEvent) {
      const levels = ['inactive', 'start_action', 'monitored_action', 'maintained_behaviour'];
      const notSupportedLevels = levels.filter(level => !this.allowedLevels.includes(level));
      const notSupportedElements = []

      // get elements for not supported levels
      notSupportedLevels.forEach(level => {
        const nodes = document.querySelectorAll(`.${level}`);
        const inOrder = this.getOrderNumber() !== null
        inOrder && notSupportedElements.push(nodes[this.getOrderNumber()])
      })

      // get coordinates of not supported elements
      const notSupportedCoords = [...notSupportedElements].map(item => item.getBoundingClientRect())

      // check if dropped item in not supported LOG based on coordinates
      const notSupported = notSupportedCoords.some(item => {
        const inBetween =
          originalEvent.clientX > item.left &&
          originalEvent.clientX < item.right &&
          originalEvent.clientY > item.top &&
          originalEvent.clientY < item.bottom
        return inBetween;
      })

      // show message if dropped item in not suppoerted LOG
      if (notSupported) {
        this.$toasted.show(
          this.$t('journeyBehaviourChangeGoals.notSupportedGoal'),
          {position: 'bottom-center'}
        );
      }
    },

    getOrderNumber() {
      switch(this.behaviourComponent) {
        case 'MEDICATIONS':
          return 0;
        case 'STARTMOVING':
          return 1;
        case 'HEALTHYNUTRITION':
          return 2;
        case 'SMOKECESSATION':
          return 3;
        case 'STRESSMANAGEMENT':
          return 4;
        default:
          return null;
      }
    },

  },
  mounted: function () {
    this.setActiveLevel();
  },
  components: {
    draggable,
  },
};
</script>

<style lang="scss">
@import "../../../../scss/colors";

.v-card {
  min-height: 100px;
  background-color: #f2f8ff;
}

.v-icon {
  color: #0057c2;
}

.draggable {
  background-color: #f8f8f8;
}

.v-application:not(.v-application.cursor-grabbing) {
  .draggable {
    .v-card {
      cursor: move;
      cursor: grab;
    }
  }
}

.cursor-grabbing {
  cursor: move !important;
  cursor: grabbing !important;
}

.draggable.inactive, .draggable.disabled {
  .v-card {
    background-color: #f6f6f8 !important;
    cursor: not-allowed !important;
  }

  .v-icon {
    color: rgba(0,0,0,0.3) !important;
  }

  p {
    color: rgba(0,0,0,0.3) !important;
  }
}
</style>